import './styles/_collection-items-header.scss';
import { onDocumentReady } from '../utils/dom';
import Swiper, { Mousewheel } from 'swiper';

Swiper.use([Mousewheel]);

const state = {
  elements: {},
  currentIndex: 0,
};

const cacheState = () => {
  state.elements = {
    collectionSections: document.querySelectorAll(".collection-items-header"),
    collectionItemsHeader: document.querySelector('.collection-items-header'),
    collectionItems: document.querySelectorAll('.collection-items-header-item'),
    hiddenBlocks: Array.from(document.querySelectorAll(".hidden-block")),
    infiniteBtn: document.getElementById("collection-items-loader"),
    loadMoreButton: document.getElementById("load-more-btn"),
    panelButtons: document.querySelectorAll('.collection-items__panel--button'),
    panelCloseButtons: document.querySelectorAll('.collection-items__panel--close'),
    panelItems: document.querySelectorAll(".collection-items__panel"),
    mobileScreenWidth: 768
  };
};

const revealUpToTarget = (targetIndex) => {
  state.elements.hiddenBlocks.forEach((block) => {
    const blockIndex = parseInt(block.getAttribute('data-index'), 10);

    if (blockIndex <= targetIndex) {
      block.classList.remove('hidden-block');
    }
  });

  if (state.elements.hiddenBlocks.length === 0) {
    state.elements?.loadMoreButton?.classList.add('unvisible');
  }
};

const scrollToItem = function (e) {
  e.preventDefault();
  const targetId = this.getAttribute('href').substring(1);
  const targetElement = document.getElementById(targetId);
  const timeout = parseInt(
    state.elements.collectionItemsHeader.getAttribute('data-timeout'),
    10
  ) || 800;

  if (targetElement) {
    const targetIndex = parseInt(targetElement.getAttribute('data-index'), 10);
    const remainingItems = state.elements.hiddenBlocks.length - state.currentIndex;
    const itemsToShow = Math.min(3, remainingItems);
    state.currentIndex += itemsToShow;
    localStorage.setItem('currentIndex', state.elements.hiddenBlocks.length - state.currentIndex);

    revealUpToTarget(targetIndex);

    const isMobile = window.innerWidth <= state.elements.mobileScreenWidth;
    const offset = isMobile ? 45 : 82;
    const targetPosition =
      targetElement.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth',
    });

    setTimeout(() => {
      const button = targetElement.querySelector('.collection-items_shop-button');
      if (button) {
        button.click();
      }
    }, timeout);
  }
};

const loadMore = () => {
  const { hiddenBlocks } = state.elements;

  const itemsToShow = Math.min(3, hiddenBlocks.length - state.currentIndex);
  for (let i = 0; i < itemsToShow; i++) {
    hiddenBlocks[state.currentIndex + i].classList.remove("hidden-block");
  }

  state.currentIndex += itemsToShow;
  localStorage.setItem('currentIndex', state.currentIndex);
};

const panelModal = (button) => {
  const parent = button.closest('.collection-items_shop');
  const panel = parent.querySelector('.collection-items__panel');
  panel.classList.toggle('active');
};

const initializeSwiper = () => {
  state.elements.collectionSections.forEach(item => {
    const swiper = new Swiper(item, {
      slidesPerView: 'auto',
      spaceBetween: 10, 
      freeMode: true, 
      mousewheel: {
        forceToAxis: true,
        sensitivity: 10,
        releaseOnEdges: true,
        thresholdDelta: 100,
        thresholdTime: 2000,
      },
    });
  });
};

const attachEventListeners = () => {
  state.elements.collectionItems.forEach((item) =>
    item.addEventListener("click", scrollToItem)
  );
  state.elements?.panelButtons.forEach((button) => {
    button?.addEventListener("click", () => {
      state.elements.panelItems.forEach(panel => panel.classList.remove('active'));
      panelModal(button);
    });
  });
  state.elements.panelCloseButtons.forEach((button) => {
    button?.addEventListener("click", () => {
      const panel = button.closest('.collection-items__panel');
      if (panel) {
        panel.classList.remove('active');
      }
    });
  })
  if(state.elements.loadMoreButton) state.elements.loadMoreButton.addEventListener("click", loadMore);
};

const mergeCollectionItems = () => {
  const sections = state.elements.collectionSections;
  if (sections.length === 0) return;
  
  const [firstSection, ...remainingSections] = sections;
  const firstSectionWrapper = firstSection.querySelector('.collection-items-header-wrapper');
  const fragment = document.createElement('div');

  firstSection.classList.remove('hidden');

  if (remainingSections.length === 0) return;

  remainingSections.forEach(section => {
    const headerWrapper = section.querySelector('.collection-items-header-wrapper');

    if (headerWrapper) {
      fragment.innerHTML += headerWrapper.innerHTML;
    }

    section.remove();
  });

  firstSectionWrapper.innerHTML += fragment.innerHTML;
};

const init = () => {
  cacheState();
  attachEventListeners();
  mergeCollectionItems();
  initializeSwiper();
};

onDocumentReady(init);